module.exports = __webpack_public_path__ + "static/employee-experience-design-4518e10858557d528b73d578005305ad.png";